import React, { useState, useEffect } from 'react';
import './AdminDashboard.css'; // Reuse the same CSS file
import axiosInstance from './axiosInstance'; // Import the axios instance

const AdminNewsletters = ({ showNames }) => {
    const [adminFirstName, setAdminFirstName] = useState('Admin');
    const [newsletters, setNewsletters] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const newslettersPerPage = 10;
    const [showSendModal, setShowSendModal] = useState(false);
    const [sendFormData, setSendFormData] = useState({ subject: '', message: '' });

    useEffect(() => {
        const fetchSubscribers = async () => {
            try {
                const response = await axiosInstance.get('/admin/subscribers');
                const formattedData = response.data.map(subscriber => ({
                    ...subscriber,
                    createdAt: new Date(subscriber.createdAt).toLocaleDateString('en-US', {
                        year: 'numeric',
                        month: '2-digit',
                        day: '2-digit'
                    })
                }));
                setNewsletters(formattedData);
            } catch (error) {
                console.error('Failed to fetch subscribers', error);
            }
        };

        fetchSubscribers();
    }, []);

    useEffect(() => {
        const fetchAdminFirstName = async () => {
            try {
                const response = await axiosInstance.get('/admin/first-name');
                setAdminFirstName(response.data.first_name);
            } catch (err) {
                console.error('Failed to fetch admin first name', err);
            }
        };

        fetchAdminFirstName();
    }, []);

    // Calculate the current newsletter to display
    const indexOfLastNewsletter = currentPage * newslettersPerPage;
    const indexOfFirstNewsletter = indexOfLastNewsletter - newslettersPerPage;
    const currentNewsletters = newsletters.slice(indexOfFirstNewsletter, indexOfLastNewsletter);

    // Handle pagination
    const nextPage = () => {
        if (currentPage < Math.ceil(newsletters.length / newslettersPerPage)) {
            setCurrentPage(currentPage + 1);
        }
    };

    const prevPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const handleSendFormChange = (e) => {
        const { name, value } = e.target;
        setSendFormData({ ...sendFormData, [name]: value });
    };

    const handleSendNewsletter = async (e) => {
        e.preventDefault();
        try {
            await axiosInstance.post('/admin/send-newsletter', sendFormData);
            setShowSendModal(false);
            setSendFormData({ subject: '', message: '' });
        } catch (err) {
            console.error('Failed to send newsletter', err);
        }
    };

    const cardStyle = {
        padding: '16px',
        borderRadius: '8px',
        backgroundColor: '#2d2d2d',
        color: 'white',
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
        transition: 'transform 0.3s, box-shadow 0.3s, border-color 0.3s',
        border: '2px solid #ff7c0a',
    };

    const titleStyle = {
        fontSize: '1.5rem',
        fontWeight: 'bold',
        marginTop: '16px',
        color: '#ff7c0a',
    };

    const buttonStyle = {
        backgroundColor: '#ff7c0a',
        color: 'white',
        padding: '10px 20px',
        border: 'none',
        borderRadius: '5px',
        cursor: 'pointer',
        margin: '5px',
        fontWeight: 'semibold',
    };

    const cancelButtonStyle = {
        ...buttonStyle,
        backgroundColor: 'white',
        color: '#ff7c0a',
        fontWeight: 'semibold',
    };

    return (
        <div className={`admin-dashboard-container ${showNames ? 'show-names' : ''}`}>
            <div className="mini-header">
                <h1 className="mini-header-title">Admin Newsletter</h1>
                <div className="mini-header-right">
                    <span className="admin-name">{adminFirstName}</span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 32 32">
                        <path fill="currentColor" d="M23 9A7 7 0 1 1 9 9a7 7 0 0 1 14 0m-2 0a5 5 0 1 0-10 0a5 5 0 0 0 10 0M7.5 18A3.5 3.5 0 0 0 4 21.5v.5c0 2.393 1.523 4.417 3.685 5.793C9.859 29.177 12.802 30 16 30s6.14-.823 8.315-2.207C26.477 26.417 28 24.393 28 22v-.5a3.5 3.5 0 0 0-3.5-3.5zM6 21.5A1.5 1.5 0 0 1 7.5 20h17a1.5 1.5 0 0 1 1.5 1.5v.5c0 1.473-.94 2.949-2.759 4.106C21.434 27.256 18.877 28 16 28s-5.434-.744-7.241-1.894C6.939 24.95 6 23.472 6 22z" />
                    </svg>
                </div>
            </div>
            <div className="dashboard-container">
                <button className="send-newsletters-button" onClick={() => setShowSendModal(true)}>Send Newsletters</button>
                <div className="dashboard-content">
                    <div className="admin-newsletters-table-container">
                        <table className="admin-newsletters-table">
                            <thead>
                                <tr>
                                    <th>S/N</th>
                                    <th>Email Address</th>
                                    <th>Date</th>
                                </tr>
                            </thead>
                            <tbody>
                                {currentNewsletters.map((newsletter, index) => (
                                    <tr key={newsletter.id}>
                                        <td>{indexOfFirstNewsletter + index + 1}</td>
                                        <td>{newsletter.email}</td>
                                        <td>{newsletter.createdAt}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    <div className="pagination">
                        <button onClick={prevPage} disabled={currentPage === 1}>Previous</button>
                        <button onClick={nextPage} disabled={currentPage === Math.ceil(newsletters.length / newslettersPerPage)}>Next</button>
                    </div>
                    <div className="pagination-info">
                        <p>Showing {indexOfFirstNewsletter + 1} to {Math.min(indexOfLastNewsletter, newsletters.length)} of {newsletters.length} newsletters</p>
                    </div>
                </div>
            </div>
            {showSendModal && (
                <div className="modal">
                    <div style={cardStyle}>
                        <h3 style={titleStyle}>Send Newsletter</h3>
                        <div style={{ padding: '16px' }}>
                        <form onSubmit={handleSendNewsletter}>
                            <div className="form-group">
                                <label htmlFor="subject" className="form-label" style={{color: '#ff7c0a'}}>Subject</label>
                                <input
                                    type="text"
                                    id="subject"
                                    name="subject"
                                    className="form-input"
                                    value={sendFormData.subject}
                                    onChange={handleSendFormChange}
                                />
                            </div>
                            <div className="form-group">
                                <label htmlFor="message" className="form-label" style={{color: '#ff7c0a'}}>Message</label>
                                <textarea
                                    id="message"
                                    name="message"
                                    className="form-input"
                                    value={sendFormData.message}
                                    onChange={handleSendFormChange}
                                />
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'center', marginTop: '16px' }}>
                                <button type="submit" style={buttonStyle}>Send</button>
                                <button type="button" style={cancelButtonStyle} onClick={() => setShowSendModal(false)}>Cancel</button>
                            </div>
                        </form>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default AdminNewsletters;